import React, { useState } from 'react';
import { Icon, Info } from '@onward-delivery/design/icons';

import GuideDialog from './GuideDialog';

/**
 * The info button at the top right of the Accounts page (onboarding view) and the `kind`'s guide dialog it opens.
 * The guide is reference content with no data behind it, so its open state lives here with the button.
 *
 * @param {{ kind: 'carrier'|'shipper' }} props
 */
const GuideButton = ({ kind }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="onward-design">
            <button
                type="button"
                aria-label="What the onboarding tabs and badges mean"
                title="What the onboarding tabs and badges mean"
                onClick={() => setOpen(true)}
                className="inline-flex size-9 items-center justify-center rounded-md bg-transparent text-muted hover:bg-muted/10 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
            >
                <Icon icon={Info} size="md" />
            </button>
            <GuideDialog kind={kind} open={open} onClose={() => setOpen(false)} />
        </div>
    );
};

export default GuideButton;
